import { Color } from 'shared/utils/colors';
import { sxStyles } from 'components/common/dataGrid/styles';

const recentlyUploadedHighlightColor = '#E5F6FD';

export const styles = {
  table: {
    ...sxStyles.table,
    '& .MuiDataGrid-row.archived': {
      '& .MuiDataGrid-cell': {
        color: Color.blackMuted,
      },
    },
    '& .MuiDataGrid-row.row-pending': {
      opacity: 0.5,
      pointerEvents: 'none',
      '& .MuiDataGrid-cell': {
        backgroundColor: Color.lightGray,
      },
    },
    '& .MuiDataGrid-row.drag-over': {
      outline: `1px solid ${Color.primaryOrangeWithOpacity}`,
      '& .MuiDataGrid-cell': {
        backgroundColor: Color.primaryOrangeWithOpacity,
      },
    },
    '& .MuiDataGrid-row.recently-uploaded': {
      '& .MuiDataGrid-cell': {
        backgroundColor: recentlyUploadedHighlightColor,
      },
      '&:hover .MuiDataGrid-cell': {
        backgroundColor: recentlyUploadedHighlightColor,
      },
    },
    '& .MuiDataGrid-row.directory-with-matching-files': {
      position: 'relative',
      '&::after': {
        content: 'attr(data-tooltip-text)',
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 56,
        padding: [0.5, 1],
        backgroundColor: Color.blackMuted,
        color: Color.white,
        borderRadius: 1,
        fontSize: 12,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        opacity: 0,
        transition: 'opacity 0.2s',
        zIndex: 1000,
      },
      '&:hover::after': {
        opacity: 1,
      },
    },
  },
};
